export const LOGOUT = 'logout';

